import styled, { css } from 'styled-components';
import { IconContainer } from '../icon/icon';

export const TooltipContainer = styled.div`
  display: inline-flex;
  position: relative;
  align-items: center;
  cursor: pointer;
  text-transform: none;

  > ${IconContainer} {
    margin-left: 0.3rem;
  }

  &:hover > span {
    color: var(--color-text-lighter);
  }

  &:hover ${IconContainer} {
    color: var(--color-text-lighter);
  }
`;

export const Header = styled.div`
  font-weight: 600;
  white-space: nowrap;
  margin-bottom: var(--spacing);
  padding-bottom: var(--spacing);
  color: var(--color-text);
  border-bottom: solid 1px var(--color-text-lightest);
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.25rem 0;
  font-weight: 400;

  &:not(:first-child) {
    margin-top: var(--spacing);
  }
`;

export const HoverWindow = styled.div`
  position: absolute;
  top: ${({ position }) => position.top}px;
  left: ${({ position }) => position.left}px;
  display: flex;
  flex-direction: column;

  width: min-content;
  min-width: ${({ noMinWidth }) => (noMinWidth ? 'unset' : '20rem')};
  padding: 1rem;

  background: var(--color-modal);
  border: 1px solid var(--color-text-lightest);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);

  font-size: var(--font-size-sm);
  color: var(--color-text-darkest);

  white-space: normal;
  z-index: 999999 !important;

  --spacing: 0.5rem;

  ${({ small }) =>
    small &&
    css`
      font-size: var(--font-size-xs);
      padding: 0.75rem;

      --spacing: 0.25rem;
    `}
`;
